import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Scan } from 'lucide-react'
import Cookies from 'js-cookie'
import axios from 'axios'
import nextlead_logo from '../imgs/nextlead-logo.png'
import topseller_logo from '../imgs/topseller-logo.png'
import { BASE_URL , NAME } from '../apiConfig'
import { useTranslation } from '../LanguageContext'
import { useAuth } from '../AuthContext'

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
  { code: 'ar', label: 'AR' },
]

export default function Header({ toggleNavbar }) {
  const navigate = useNavigate()
  const { t, lang, setLang } = useTranslation()
  const { user, logout: authLogout } = useAuth()

  const logos = {
    nextlead: nextlead_logo,
    topseller: topseller_logo,
  };
  const logo = logos[NAME];

  const logout = async () => {
    try {
      const token = Cookies.get('WEB_SSR')
      
      await axios.post(`${BASE_URL}/api/logout`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })

      Cookies.remove('WEB_SSR')
      authLogout()
      navigate('/')
      
    } catch (error) {
      Cookies.remove('WEB_SSR')
      authLogout()
      navigate('/')
    }
  }

  const userInitial = user?.name ? user.name.charAt(0).toUpperCase() : 'A'

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">
  <div className=" mx-auto px-5">
    <div className="flex h-16 items-center justify-between">
      
      <div className="flex items-center">
      <button onClick={toggleNavbar} className="md:hidden p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
        <div className="flex items-center">
            <img 
              src={logo} 
              alt="logo" 
              className={`${NAME === 'nextlead' ? 'w-44 max-lg:w-28' : 'w-28 max-lg:w-28'}`}
            />
        </div>
      </div>

      <div className="flex items-center gap-4">
        
        <div className="hidden lg:block relative" >
          <div  className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <input
            type="search"
            placeholder={t('search')}
            className="pl-10 pr-4 py-2 w-64 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent"
          />
        </div>

        <div className="flex items-center bg-gray-100 rounded-lg p-1 gap-1.5">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => setLang(l.code)}
              className={`px-2 py-1 text-xs font-medium rounded-md transition-all ${
                lang === l.code
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="group relative border-l border-gray-200 pl-2">
          <button className="flex items-center space-x-3 p-1 rounded-lg hover:bg-gray-100 transition-colors">
            <div className="h-8 w-8 rounded-full bg-gradient-to-br from-amber-400 to-amber-500 flex items-center justify-center">
              <span className="text-sm font-medium text-white">{userInitial}</span>
            </div>
            <div className="hidden md:block text-left">
              <p className="text-sm font-medium text-gray-900">{user?.name || t('admin')}</p>
              <p className="text-xs text-gray-500">{user?.role?.name || t('administrator')}</p>
            </div>
            <svg className="h-5 w-5 text-gray-400 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          
          <div className={`absolute ${lang === 'ar' ? 'left-5' : 'right-5'} mt-2 w-56 origin-top-right rounded-lg border border-gray-200 bg-white py-2 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200`}>
            <div className="px-4 py-3 border-b border-gray-100">
              <p className="text-sm font-medium text-gray-900">{user?.name || t('admin')}</p>
              <p className="text-xs text-gray-500">{user?.email || t('admin.email')}</p>
            </div>
            <div className="border-t border-gray-100 my-2"></div>
            <button onClick={logout} className="flex w-full items-center px-4 py-2.5 text-sm text-red-600 hover:bg-gray-50 transition-colors">
              <svg className="mr-3 h-4 w-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
              </svg>
              {t('logout')}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
  )
}
